(ns ^:dev/always bp-clients.tv-app.api.graphql.search
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/search/search.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private search-raw (get-in query-map [:query :tv-app-search]))

(defn search-query
  "Sends a token-valid query"
  [{:keys [search-terms]}]
  (query-builder search-raw {:search_terms search-terms}))

(comment
  ;; see the corresponding .graphql files for more impormation

  (search-query {:search-terms "my search"})

  nil)
